import React, { useEffect, useState } from "react";
import { Effect } from "../../types/effects";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { selectUserGlobalData } from "../../store/dreamworldSlice";
import { AppDispatch, RootState } from "../../store/store";
import { getRecentEffects, selectRecentEffects, selectRecentEffectsLoading } from "../../store/discoverSlice";
import LoadingIndicator from "../ui/LoadingIndicator";
import AllRecentEffectsModal from "../modals/AllRecentEffectsModal";
import Section from "../ui/Section";

interface RecentEffectsProps {
  onEffectClick: (effect: Effect) => void;
}

const RecentEffects: React.FC<RecentEffectsProps> = ({
  onEffectClick,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const effects = useSelector(selectRecentEffects);
  const loading = useSelector(selectRecentEffectsLoading);
  const userGlobalData = useSelector(selectUserGlobalData);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (userGlobalData?.user?.uid) {
      dispatch(getRecentEffects(userGlobalData.user.uid));
    }
  }, [userGlobalData, dispatch]);

  return (
    <>
      <Section title="Recent Effects" onSeeAll={() => setIsModalOpen(true)}>
        <div className="relative">
          {loading === "pending" && effects.length === 0 ? (
            <div className="flex justify-center items-center h-48">
              <LoadingIndicator />
            </div>
          ) : (
            <div className="flex space-x-4 overflow-x-auto p-4">
              {effects.map((effect) => (
                <motion.div
                  key={effect.id}
                  className="flex-shrink-0 w-64 bg-gray-800 rounded-lg shadow-lg cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                  onClick={() => onEffectClick(effect)}
                >
                  <img
                    src={effect.image}
                    alt={effect.title}
                    className="w-full h-32 object-cover rounded-t-lg"
                  />
                  <div className="p-4">
                    <h3 className="text-white font-semibold">{effect.title}</h3>
                    <p className="text-gray-400 text-sm line-clamp-3">
                      {effect.description}
                    </p>
                    <p className="text-purple-400 text-xs mt-2">
                      Used {effect.useCount} times
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </Section>
      {isModalOpen && (
        <AllRecentEffectsModal onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default RecentEffects;
